/* import __COLOCATED_TEMPLATE__ from './post-enqueued.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();